export default "__VITE_ASSET__ddb49817__"